/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { AllSystemResourceQueryResDTO, ButtonResourceCreateReqDTO, ButtonResourceDataResDTO, ButtonResourceUpdateReqDTO, MenuResourceCreateReqDTO, MenuResourceDataResDTO, MenuResourceUpdateReqDTO, ResourceTypeListResDTO, ResourceTypeResData, Result, RoleCreateReqDTO, RoleDataQueryResDTO, RoleListResDTO, RoleResourceRelationCreateByResourceCodeReqDTO, RoleResourceRelationDeleteReqDTO, RoleResourceRelationQueryByResourceIdResDTO, RoleResourceRelationQueryByRoleIdResDTO, RoleResourceRelationReqDTO, RoleResourceRelationResData, RoleUpdateReqDTO, RoleUserInfoReqDTO, RoleUserInfoResDTO, RoleUserRelationInfoData, SystemInnerResourceResDTO, SystemResourceCreateReqDTO, SystemResourceDataResDTO, SystemResourceRoleRelationUpdateReqDTO, SystemResourceUpdateReqDTO, UserInfoResDTO, UserRoleInfoResDTO, UserRoleRelationBizCreateReqDTO, UserRoleRelationDeleteReqDTO, UserRoleResourceInfoResDTO, UserSystemInnerPermissionListResDTO, UserSystemInnerResourcePermissionListResDTO, UserSystemResourcePermissionListResDTO, ButtonResourceController, DataResourceController, MenuResourceController, ResourceController, RoleController, RoleResourceRelationController, SystemResourceController, UserResourcePermissionController, UserRoleRelationController, ApiUserRoleRelationController, ServiceHandler } from './types'
import $http from '../request'
import { BaseRequestDTO } from '../types'

export * from './types'

const basePath = ''

export const buttonResourceController: ButtonResourceController = {

  async create(req: ButtonResourceCreateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/buttonResource`
    const payload: ButtonResourceCreateReqDTO = req
    const ret = await $http.run<ButtonResourceCreateReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async update(req: ButtonResourceUpdateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/buttonResource`
    const payload: ButtonResourceUpdateReqDTO = req
    const ret = await $http.run<ButtonResourceUpdateReqDTO, Result<void>>(path, 'PUT', payload)
    return ret
  },

  async deleteByResourceCode(resourceCode: string): Promise<Result<void>> {
    const path = `${basePath}/management/permission/buttonResource/deleteByResourceCode/{resourceCode}`
    const payload: BaseRequestDTO = { resourceCode }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async queryByResourceCode(resourceCode: string): Promise<Result<ButtonResourceDataResDTO>> {
    const path = `${basePath}/management/permission/buttonResource/queryByResourceCode/{resourceCode}`
    const payload: BaseRequestDTO = { resourceCode }
    const ret = await $http.run<BaseRequestDTO, Result<ButtonResourceDataResDTO>>(path, 'GET', payload)
    return ret
  },

  async query(id: number): Promise<Result<ButtonResourceDataResDTO>> {
    const path = `${basePath}/management/permission/buttonResource/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<ButtonResourceDataResDTO>>(path, 'GET', payload)
    return ret
  },

  async delete(id: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/buttonResource/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  }
}

export const dataResourceController: DataResourceController = {

  async create_1(): Promise<Result<void>> {
    const path = `${basePath}/management/permission/dataResource`
    const payload = null
    const ret = await $http.run<null, Result<void>>(path, 'POST', payload)
    return ret
  },

  async deleteByResourceCode_1(resourceCode: string): Promise<Result<void>> {
    const path = `${basePath}/management/permission/dataResource/deleteByResourceCode/{resourceCode}`
    const payload: BaseRequestDTO = { resourceCode }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async delete_1(id: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/dataResource/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  }
}

export const menuResourceController: MenuResourceController = {

  async create_2(req: MenuResourceCreateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/menuResource`
    const payload: MenuResourceCreateReqDTO = req
    const ret = await $http.run<MenuResourceCreateReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async update_1(req: MenuResourceUpdateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/menuResource`
    const payload: MenuResourceUpdateReqDTO = req
    const ret = await $http.run<MenuResourceUpdateReqDTO, Result<void>>(path, 'PUT', payload)
    return ret
  },

  async deleteByResourceCode_2(resourceCode: string): Promise<Result<void>> {
    const path = `${basePath}/management/permission/menuResource/deleteByResourceCode/{resourceCode}`
    const payload: BaseRequestDTO = { resourceCode }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async queryButtonResourceById(id: number): Promise<Result<MenuResourceDataResDTO>> {
    const path = `${basePath}/management/permission/menuResource/queryButtonResourceById/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<MenuResourceDataResDTO>>(path, 'GET', payload)
    return ret
  },

  async queryByResourceCode_1(resourceCode: string): Promise<Result<MenuResourceDataResDTO>> {
    const path = `${basePath}/management/permission/menuResource/queryByResourceCode/{resourceCode}`
    const payload: BaseRequestDTO = { resourceCode }
    const ret = await $http.run<BaseRequestDTO, Result<MenuResourceDataResDTO>>(path, 'GET', payload)
    return ret
  },

  async query_1(id: number): Promise<Result<MenuResourceDataResDTO>> {
    const path = `${basePath}/management/permission/menuResource/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<MenuResourceDataResDTO>>(path, 'GET', payload)
    return ret
  },

  async delete_2(id: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/menuResource/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  }
}

export const resourceController: ResourceController = {

  async listResourceType(): Promise<Result<ResourceTypeListResDTO>> {
    const path = `${basePath}/management/permission/resource/listResourceType`
    const payload = null
    const ret = await $http.run<null, Result<ResourceTypeListResDTO>>(path, 'GET', payload)
    return ret
  }
}

export const roleController: RoleController = {

  async create_3(req: RoleCreateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/role`
    const payload: RoleCreateReqDTO = req
    const ret = await $http.run<RoleCreateReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async update_2(req: RoleUpdateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/role`
    const payload: RoleUpdateReqDTO = req
    const ret = await $http.run<RoleUpdateReqDTO, Result<void>>(path, 'PUT', payload)
    return ret
  },

  async queryByRoleCode(roleCode: string): Promise<Result<RoleDataQueryResDTO>> {
    const path = `${basePath}/management/permission/role/queryByRoleCode/{roleCode}`
    const payload: BaseRequestDTO = { roleCode }
    const ret = await $http.run<BaseRequestDTO, Result<RoleDataQueryResDTO>>(path, 'GET', payload)
    return ret
  },

  async queryRoleList(): Promise<Result<RoleListResDTO>> {
    const path = `${basePath}/management/permission/role/queryRoleList`
    const payload = null
    const ret = await $http.run<null, Result<RoleListResDTO>>(path, 'GET', payload)
    return ret
  },

  async query_2(id: number): Promise<Result<RoleDataQueryResDTO>> {
    const path = `${basePath}/management/permission/role/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<RoleDataQueryResDTO>>(path, 'GET', payload)
    return ret
  },

  async delete_3(id: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/role/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  }
}

export const roleResourceRelationController: RoleResourceRelationController = {

  async create_4(req: RoleResourceRelationReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/roleResourceRelation`
    const payload: RoleResourceRelationReqDTO = req
    const ret = await $http.run<RoleResourceRelationReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async createRelationByResourceCode(req: RoleResourceRelationCreateByResourceCodeReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/roleResourceRelation/createRelationByResourceCode`
    const payload: RoleResourceRelationCreateByResourceCodeReqDTO = req
    const ret = await $http.run<RoleResourceRelationCreateByResourceCodeReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async deleteByResourceIdAndRoleId(req: RoleResourceRelationDeleteReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/roleResourceRelation/deleteByResourceIdAndRoleId`
    const payload: RoleResourceRelationDeleteReqDTO = req
    const ret = await $http.run<RoleResourceRelationDeleteReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async deleteByResourceId(resourceId: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/roleResourceRelation/deleteByRoleId/{resourceId}`
    const payload: BaseRequestDTO = { resourceId }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async deleteByRoleId(roleId: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/roleResourceRelation/deleteByRoleId/{roleId}`
    const payload: BaseRequestDTO = { roleId }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async queryByResourceId(resourceId: number): Promise<Result<RoleResourceRelationQueryByResourceIdResDTO>> {
    const path = `${basePath}/management/permission/roleResourceRelation/queryByResourceId/{resourceId}`
    const payload: BaseRequestDTO = { resourceId }
    const ret = await $http.run<BaseRequestDTO, Result<RoleResourceRelationQueryByResourceIdResDTO>>(path, 'GET', payload)
    return ret
  },

  async queryByRoleId(roleId: number): Promise<Result<RoleResourceRelationQueryByRoleIdResDTO>> {
    const path = `${basePath}/management/permission/roleResourceRelation/queryByRoleId/{roleId}`
    const payload: BaseRequestDTO = { roleId }
    const ret = await $http.run<BaseRequestDTO, Result<RoleResourceRelationQueryByRoleIdResDTO>>(path, 'GET', payload)
    return ret
  },

  async updateSystemResourceRoleRelation(req: SystemResourceRoleRelationUpdateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/roleResourceRelation/updateSystemResourceRoleRelation`
    const payload: SystemResourceRoleRelationUpdateReqDTO = req
    const ret = await $http.run<SystemResourceRoleRelationUpdateReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async delete_4(id: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/roleResourceRelation/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  }
}

export const systemResourceController: SystemResourceController = {

  async create_5(req: SystemResourceCreateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/systemResource`
    const payload: SystemResourceCreateReqDTO = req
    const ret = await $http.run<SystemResourceCreateReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async update_3(req: SystemResourceUpdateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/systemResource`
    const payload: SystemResourceUpdateReqDTO = req
    const ret = await $http.run<SystemResourceUpdateReqDTO, Result<void>>(path, 'PUT', payload)
    return ret
  },

  async deleteByResourceCode_3(resourceCode: string): Promise<Result<void>> {
    const path = `${basePath}/management/permission/systemResource/deleteByResourceCode/{resourceCode}`
    const payload: BaseRequestDTO = { resourceCode }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async deleteBySystemCode(systemCode: string): Promise<Result<void>> {
    const path = `${basePath}/management/permission/systemResource/deleteBySystemCode/{systemCode}`
    const payload: BaseRequestDTO = { systemCode }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async queryAllSystemResource(): Promise<Result<AllSystemResourceQueryResDTO>> {
    const path = `${basePath}/management/permission/systemResource/queryAllSystemResource`
    const payload = null
    const ret = await $http.run<null, Result<AllSystemResourceQueryResDTO>>(path, 'GET', payload)
    return ret
  },

  async queryByResourceCode_2(resourceCode: string): Promise<Result<SystemResourceDataResDTO>> {
    const path = `${basePath}/management/permission/systemResource/queryByResourceCode/{resourceCode}`
    const payload: BaseRequestDTO = { resourceCode }
    const ret = await $http.run<BaseRequestDTO, Result<SystemResourceDataResDTO>>(path, 'GET', payload)
    return ret
  },

  async queryBySystemCode(systemCode: string): Promise<Result<SystemResourceDataResDTO>> {
    const path = `${basePath}/management/permission/systemResource/queryBySystemCode/{systemCode}`
    const payload: BaseRequestDTO = { systemCode }
    const ret = await $http.run<BaseRequestDTO, Result<SystemResourceDataResDTO>>(path, 'GET', payload)
    return ret
  },

  async querySystemInnerResourceById(id: number): Promise<Result<SystemInnerResourceResDTO>> {
    const path = `${basePath}/management/permission/systemResource/querySystemInnerResourceById/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<SystemInnerResourceResDTO>>(path, 'GET', payload)
    return ret
  },

  async querySystemInnerResourceBySystemCode(systemCode: string): Promise<Result<SystemInnerResourceResDTO>> {
    const path = `${basePath}/management/permission/systemResource/querySystemInnerResourceBySystemCode/{systemCode}`
    const payload: BaseRequestDTO = { systemCode }
    const ret = await $http.run<BaseRequestDTO, Result<SystemInnerResourceResDTO>>(path, 'GET', payload)
    return ret
  },

  async deleteBySystemResourceId(id: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/systemResource/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async queryBySystemResourceId(systemResourceId: number): Promise<Result<SystemResourceDataResDTO>> {
    const path = `${basePath}/management/permission/systemResource/{systemResourceId}`
    const payload: BaseRequestDTO = { systemResourceId }
    const ret = await $http.run<BaseRequestDTO, Result<SystemResourceDataResDTO>>(path, 'GET', payload)
    return ret
  }
}

export const userResourcePermissionController: UserResourcePermissionController = {

  async listUserSystemInnerPermission(id: number): Promise<Result<UserSystemInnerPermissionListResDTO>> {
    const path = `${basePath}/management/permission/userResourcePermission/listUserSystemInnerPermission/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<UserSystemInnerPermissionListResDTO>>(path, 'GET', payload)
    return ret
  },

  async listUserSystemInnerResourcePermission(id: number): Promise<Result<UserSystemInnerResourcePermissionListResDTO>> {
    const path = `${basePath}/management/permission/userResourcePermission/listUserSystemInnerResourcePermission/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<UserSystemInnerResourcePermissionListResDTO>>(path, 'GET', payload)
    return ret
  },

  async listUserSystemInnerResourcePermissionByCode(systemCode: string): Promise<Result<UserSystemInnerResourcePermissionListResDTO>> {
    const path = `${basePath}/management/permission/userResourcePermission/listUserSystemInnerResourcePermissionByCode/{systemCode}`
    const payload: BaseRequestDTO = { systemCode }
    const ret = await $http.run<BaseRequestDTO, Result<UserSystemInnerResourcePermissionListResDTO>>(path, 'GET', payload)
    return ret
  },

  async listUserSystemResourcePermission(): Promise<Result<UserSystemResourcePermissionListResDTO>> {
    const path = `${basePath}/management/permission/userResourcePermission/listUserSystemResourcePermission`
    const payload = null
    const ret = await $http.run<null, Result<UserSystemResourcePermissionListResDTO>>(path, 'GET', payload)
    return ret
  }
}

export const userRoleRelationController: UserRoleRelationController = {

  async create_6(req: UserRoleRelationBizCreateReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/userRoleRelation`
    const payload: UserRoleRelationBizCreateReqDTO = req
    const ret = await $http.run<UserRoleRelationBizCreateReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async deleteByUserUid(userUid: string): Promise<Result<void>> {
    const path = `${basePath}/management/permission/userRoleRelation/deleteByUserUid/{userUid}`
    const payload: BaseRequestDTO = { userUid }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  },

  async deleteUserRoleRelation(req: UserRoleRelationDeleteReqDTO): Promise<Result<void>> {
    const path = `${basePath}/management/permission/userRoleRelation/deleteUserRoleRelation`
    const payload: UserRoleRelationDeleteReqDTO = req
    const ret = await $http.run<UserRoleRelationDeleteReqDTO, Result<void>>(path, 'POST', payload)
    return ret
  },

  async queryRoleUserInfo(roleId: number): Promise<Result<RoleUserInfoResDTO>> {
    const path = `${basePath}/management/permission/userRoleRelation/queryRoleUserInfo/{roleId}`
    const payload: BaseRequestDTO = { roleId }
    const ret = await $http.run<BaseRequestDTO, Result<RoleUserInfoResDTO>>(path, 'GET', payload)
    return ret
  },

  async queryUserRoleInfo(userUid: string): Promise<Result<UserRoleInfoResDTO>> {
    const path = `${basePath}/management/permission/userRoleRelation/queryUserRoleInfo/{userUid}`
    const payload: BaseRequestDTO = { userUid }
    const ret = await $http.run<BaseRequestDTO, Result<UserRoleInfoResDTO>>(path, 'GET', payload)
    return ret
  },

  async queryUserRoleResourceInfo(userUid: string): Promise<Result<UserRoleResourceInfoResDTO>> {
    const path = `${basePath}/management/permission/userRoleRelation/queryUserRoleResourceInfo/{userUid}`
    const payload: BaseRequestDTO = { userUid }
    const ret = await $http.run<BaseRequestDTO, Result<UserRoleResourceInfoResDTO>>(path, 'GET', payload)
    return ret
  },

  async delete_5(id: number): Promise<Result<void>> {
    const path = `${basePath}/management/permission/userRoleRelation/{id}`
    const payload: BaseRequestDTO = { id }
    const ret = await $http.run<BaseRequestDTO, Result<void>>(path, 'DELETE', payload)
    return ret
  }
}

export const apiUserRoleRelationController: ApiUserRoleRelationController = {

  async queryUserRoleInfoByUserIdAndSystemResourceCode(req: RoleUserInfoReqDTO): Promise<Result<UserRoleInfoResDTO>> {
    const path = `${basePath}/permission/api/userRoleRelation/queryUserRoleInfoByUserIdAndSystemResourceCode`
    const payload: RoleUserInfoReqDTO = req
    const ret = await $http.run<RoleUserInfoReqDTO, Result<UserRoleInfoResDTO>>(path, 'POST', payload)
    return ret
  }
}
export const serviceHandler: ServiceHandler = {
  ButtonResourceController: buttonResourceController,
  DataResourceController: dataResourceController,
  MenuResourceController: menuResourceController,
  ResourceController: resourceController,
  RoleController: roleController,
  RoleResourceRelationController: roleResourceRelationController,
  SystemResourceController: systemResourceController,
  UserResourcePermissionController: userResourcePermissionController,
  UserRoleRelationController: userRoleRelationController,
  ApiUserRoleRelationController: apiUserRoleRelationController
}
